import * as React from 'react';

import Dropdown, { Option } from 'react-dropdown';
import DialogContentText from '@material-ui/core/DialogContentText';

import 'react-dropdown/style.css';

interface Props {
  placeholder?: string;
  options: string[];
  onChange: (arg: Option) => void;
  value: string;
  title: string;
  disabled?: boolean;
}

function SubDropdown (props: Props) {
  const {
    placeholder,
    options,
    onChange,
    value,
    title,
    disabled,
  } = props;

  return(
    <React.Fragment>
      <br />
      <DialogContentText>
        {title}
      </DialogContentText>
      <Dropdown
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        options={options}
        onChange={onChange} />
    </React.Fragment>
  );
  
}

export default React.memo(SubDropdown);
